import React from 'react';
import { motion } from 'framer-motion';
import { trackAddToCart } from '../utils/metaPixel';
export function OfferCTA() {
  return <section id="offer" className="py-20 md:py-32 bg-cream relative overflow-hidden" data-id="element-91">
      {/* Decorative background circle */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-sage/5 rounded-full blur-3xl -z-10" data-id="element-92"></div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-93">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} data-id="element-94">
          <h2 className="text-3xl md:text-5xl font-bold mb-6 font-playfair leading-tight" data-id="element-95">
            Obtén acceso inmediato al Botiquín Natural de Emergencia y
            transforma tu hogar en un espacio de sanación consciente.
          </h2>

          <p className="text-xl text-brown-body/80 mb-8 italic font-lora" data-id="element-96">
            (Menos de lo que cuesta una sola visita a la farmacia o el copago de
            urgencias).
          </p>

          <div className="mb-10" data-id="element-97">
            <span className="text-brown-body/50 line-through text-lg mr-3" data-id="element-98">
              $19.99
            </span>
            <span className="text-4xl md:text-5xl font-bold font-playfair text-terracotta" data-id="element-99">
              $6.39
            </span>
            <span className="block mt-2 text-sm text-sage-dark font-semibold uppercase tracking-wide" data-id="element-100">
              Precio de lanzamiento — oferta por tiempo limitado
            </span>
          </div>

          <motion.a href="https://maternidadenequilibrio.com/cart/48856065900768:1" target="_blank" rel="noopener noreferrer" onClick={() => trackAddToCart()} whileHover={{
          scale: 1.03
        }} whileTap={{
          scale: 0.97
        }} className="inline-flex items-center justify-center px-8 py-5 text-lg md:text-xl font-bold text-white bg-terracotta hover:bg-terracotta-dark rounded-xl shadow-xl shadow-terracotta/25 transition-all duration-300 w-full sm:w-auto max-w-md mx-auto" data-id="element-101">
            QUIERO EL BOTIQUÍN NATURAL AHORA
          </motion.a>

          <p className="mt-6 text-sm text-brown-body/70 font-medium" data-id="element-102">
            Acceso inmediato tras la compra. Formato digital compatible con
            cualquier dispositivo.
          </p>
        </motion.div>
      </div>
    </section>;
}